export default __webpack_public_path__ + "static/media/banner.5594216f.svg";